/**!
 * Created by Leonardo Cheslacki on 28/04/2022.
 *
 * MIT License
 *
 * Copyright (c) 2022 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import HelpersController from './HelpersController';

import WithType from './WithType';

let _this = {};

/**
 *
 */
class HelpersClass extends HelpersController {
    /**
     *
     * @param props
     * @param main
     */
    constructor(props, main) {
        super(props);
        this.props = props;
        this.main = main;

        this.state = {
            current: 0
        };

        _this = this;
    };

    /**
     *
     * @param element
     * @returns {false|string[]|*[]}
     */
    listClass = (element) => {
        let
            attribute = this.removeSpaceDuplicate(element.getAttribute('class')),
            array = Boolean(attribute) && attribute.split(' ');

        return this.isArray(array) ? array : [];
    };

    /**
     *
     * @param element
     * @param className
     * @returns {boolean}
     */
    hasClass = (element, className) => {
        className = this.removeSpaceDuplicate(className);
        if (this.isElement(element) && !this.isEmpty(className)) {
            let array = this.listClass(element);
            return this.inArray(array, className);
        }

        return false;
    };

    /**
     *
     * @param element
     * @param className
     */
    addClass = (element, className) => {
        if (!this.hasClass(element, className)) {
            className = this.removeSpaceDuplicate(className);
            if (!this.isEmpty(className)) {
                let array = this.listClass(element);
                array.push(className);
                element.setAttribute('class', array.join(' '));
            }
        }
    };

    /**
     *
     * @param element
     * @param classNames
     */
    addClasses = (element, ...classNames) => {
        if (this.isElement(element) && this.isArrayIf(classNames)) {
            for (let key in classNames) {
                this.addClass(element, classNames[key]);
            }
        }
    };

    /**
     *
     * @param element
     * @param className
     */
    removeClass = (element, className) => {
        if (this.hasClass(element, className)) {
            className = this.removeSpaceDuplicate(className);
            if (!this.isEmpty(className)) {
                let array = this.listClass(element);
                if (this.isArrayIf(array)) {
                    array = array.filter((value) => {
                        return className !== value;
                    });
                    this.isArrayIf(array) ? element.setAttribute('class', array.join(' ')) : element.removeAttribute('class');
                }
            }
        }
    };

    /**
     *
     * @param element
     * @param classNameOut
     * @param classNameIn
     */
    changeClass = (element, classNameOut, classNameIn) => {
        this.removeClass(element, classNameOut);
        this.addClass(element, classNameIn);
    };

    /**
     *
     * @param element
     * @param classNames
     */
    removeClasses = (element, ...classNames) => {
        if (this.isElement(element) && this.isArrayIf(classNames)) {
            for (let key in classNames) {
                this.removeClass(element, classNames[key]);
            }
        }
    };
}

/**
 *
 * @type {{}}
 */
HelpersClass.propTypes = {};

/**
 *
 * @type {{}}
 */
HelpersClass.defaultProps = {};

/**
 *
 * @param ClassObject
 * @param className {className: 'className'}
 * @returns {function(*): function({}=): *} pass _this ClassMain (required) and props {} (optional)
 */
export default WithType(HelpersClass, {className: 'HelpersClass'});
